import Actions from '../../Actions/Actions'
import useDashActions from './useDashActions'

const DashActions = () => {
  const { actions } = useDashActions()
  return <Actions actions={actions} />
}

export default DashActions
